import { onDocumentReady } from '@theme/utilities';
import { publish } from '@theme/analytics';

/**
 * Generic promotional-banner tracking. Any element marked `data-analytics-promotion`
 * (with `data-promotion-id`/`data-promotion-name`/`data-creative-name`/`data-creative-slot`)
 * gets view_promotion published the first time it's 50% visible, and select_promotion
 * published on click.
 */

const viewedPromotions = new WeakSet();

/** @param {HTMLElement} el */
function buildPromotionPayload(el) {
  return {
    creative_name: el.dataset.creativeName || '',
    creative_slot: el.dataset.creativeSlot || '',
    promotion_id: el.dataset.promotionId || '',
    promotion_name: el.dataset.promotionName || '',
  };
}

/** @param {HTMLElement} el */
function observeView(el) {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting || viewedPromotions.has(el)) continue;
        viewedPromotions.add(el);
        publish('view_promotion', buildPromotionPayload(el));
        observer.unobserve(el);
      }
    },
    { threshold: 0.5 }
  );

  observer.observe(el);
}

onDocumentReady(() => {
  for (const el of document.querySelectorAll('[data-analytics-promotion]')) {
    if (!(el instanceof HTMLElement)) continue;

    observeView(el);
    el.addEventListener('click', () => publish('select_promotion', buildPromotionPayload(el)));
  }
});
